<template>
	<div id="usre-baseinfor" class="oh" > 
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader></govheader>
			<div class="index_left_centerpage"> 
			 <div class="enterprise_detail gov_enterprise_detail">
			 	<div class="whitebox centerpage"> 
					<div class="d_blocktitle">
						<i class="title-icon title-icon1"></i>
						<h3 class="ctitle">{{companyinfor.title}}</h3> 
						<!-- <p>{{companyinfor.addCRMid}}</p> --> 
						<span :class="companyinfor.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{companyinfor.collectId == 0?'加入':'取消'}}关注</span> 
					</div>
					<ul class="oh conpany-infor-new"> 
						<li class="inforLine inforLine-2h"><span class="label">注册资本：</span><span class="infortext">{{companyinfor.regCapital}}</span> </li>
						<li class="inforLine inforLine-2h"><span class="label">成立时间：</span><span class="infortext">{{companyinfor.createTime}}</span> </li>
						<li class="inforLine inforLine-2h"><span class="label">法定代表人：</span><span class="infortext">{{companyinfor.legalPerson}}</span> </li> 
						<li class="inforLine inforLine-2h"><span class="label">企业类型：</span><span class="infortext">{{companyinfor.type}}</span> </li> 
						<li class="inforLine inforLine-2h"><span class="label">纳税人识别号：</span><span class="infortext">{{companyinfor.taxNo}}</span> </span>  
						<li class="inforLine inforLine-2h"><span class="label">网址：</span><span class="curp infortext" @click="rwebsite=true">{{companyinfor.website}}</span> </li> 
						<li class="inforLine inforLine-2h"><span class="label">联系邮箱：</span><span class="infortext">{{companyinfor.email}}</span> </li> 
						<li class="inforLine inforLine-one"><span class="label">企业地址：</span><span class="infortext">{{companyinfor.address}}</span> </li>  
						<li class="inforLine inforLine-one"><span class="label">经营范围：</span><span class="infortext">{{companyinfor.businessScope}}</span></li>
					</ul> 
					</div>
					<div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite=false">
						<div class="enprise_website">
							<h2>您即将跳转进入第三方网站</h2>
							<p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
							<p class="website_text">{{companyinfor.website}}</p>
							<span class="router_website" @click="geturl(companyinfor.website)" >继续前往</span>
						</div>
					</div>
					<div class="whitebox" style="padding-top:10px;">
						<div class="bdbe">
							<div class="w95mg acoltitle"><span class="" style="margin-right: 30px;">商会成员</span>  </div> 
						</div> 
						<p class="enterparise_guide oh w95mg">产业大脑为您找到{{companyinfor.enterpriseNum}}条相关结果</p> 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" style="margin-bottom: 120px;">
							<tr>
								<th class="xuhao">序号</th>
								<th>企业名称</th>
								<th>注册资本</th>
								<th>所属行业</th>
								<th>所属城市</th>
								<th>详细地址</th>
							</tr>
							<tr v-for="(list,index) in enterpriselist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td v-if="list.stockCode!=''"><span class="title onlinetitle curp" @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</span></td>
								<td v-if="list.stockCode==''">{{list.title}}</td>
								<td>{{list.regCapital.length>0?list.regCapital:'-'}}</td>
								<td>{{list.industry.length>0?list.industry:'-'}}</td>
								<td>{{list.area.length>0?list.area:'-'}}</td>
								<td>{{list.address.length>0?list.address:'-'}}</td>
							</tr>
						</table>
						<div class="centerpage1 company_pagelist" v-show="totalPage>1">
							<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
						</div>
					</div>
			</div>
		</div>
	</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'cocDetail',
	  computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
	  data(){return{
				userdata:{}, enterpriseid:0,asscociaID:0,rwebsite:false,
				title:' ', 
				companyinfor:{title:"",regCapital:"",legalPerson:"",creattime:"", taxNo:"",type:"", adress:"",email:".com",website:"",notionText:"",phone:"",	mainBusiness:""},
				enterpriselist:[],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
			}},
		 created() {
		 this.$nextTick(() => {
		 	// 禁用右键
		 	document.oncontextmenu = new Function("event.returnValue=false");
		 	// 禁用选择
		 	document.onselectstart = new Function("event.returnValue=false");
		 });
		 this.userdata=this.getuseriformation(); 
		 this.asscociaID = this.$route.query.id;  
		 this.bus.$emit('loading', true);
		 },
			mounted() { 
			 this.getbaseinfor();
			 // this.getenterpriseList()
			},
			methods:{  
				//企业网址跳转
				geturl(url) {  window.open(url); },
			 //添加删除收藏
			//获取基本信息
			getbaseinfor(){
				var _this=this;
				this.$axios.get(this.$api.cyl.commerce.detail()+'?id='+this.asscociaID , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('获取基本信息a',res.data);
					if(res.data.success){
						document.title=res.data.data.title;
					 _this.companyinfor=res.data.data; 
						_this.getenterpriseList();
					} else {
						// 
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//获取商会下企业列表
			getenterpriseList(page){
				console.log('获取商会下企业列表',this.asscociaID,this.page);
				this.bus.$emit('loading', true);
				var _this=this; 
				this.page=page?page:1; 
				this.$axios.get(this.$api.cyl.commerce.enterpriselist()+'?id='+this.asscociaID+'&page='+this.page , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('获取商会下企业列表a',res.data);
					if(res.data.success){
					  _this.enterpriselist=res.data.list; 
							_this.totalPage = res.data.totalPage;
							_this.pageSize = res.data.pageSize;
							_this.total = res.data.totalRecord;
							_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			
			//添加删除收藏
			collectFun(){
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor,'acoc');  
			}, 
			//分页跳页 
			pageHandler: function(page) { 
				this.getenterpriseList(page); 
			},	
				
				
			}
	}  
</script>

<style>
	
</style>
